import {
  ObjectPageQuery,
  FixedPriceReservationTipsQuery,
  ObjectServiceRecord,
  TextRecord,
  ConditionInfoModelRecord,
  ObjectConditionRecord,
  ObjectServicesQuery
} from '~/config/generated/graphql';

// Type gen messes up and makes all "BooleanTypes" to any and "Omit + extend" doesn't work
type MissingTypes = {
  contactSectionControllerFixedPrice: boolean;
  contactSectionControllerAuction: boolean;
};

export type CMSDataObjectPageService = ObjectServiceRecord;

const getBulletPoints = (bulletPoints?: TextRecord[]) =>
  bulletPoints?.map(bullet => bullet?.text).filter(Boolean);
export const handleObjectPageData = ({
  objectPage
}: Partial<ObjectPageQuery>) => {
  return {
    contactSection: {
      contact: objectPage?.contact[0],
      fixedPriceController: (objectPage as MissingTypes)
        ?.contactSectionControllerFixedPrice,
      auctionController: (objectPage as MissingTypes)
        ?.contactSectionControllerAuction
    },
    buyMethods: {
      biddingTutorialLink: objectPage?.buyMethodsBiddingTutorialLink,
      fixedPriceTutorialLink: objectPage?.buyMethodsFixedPriceTutorialLink,
      loanWarning: objectPage?.buyMethodsLoanWarning,
      loanCalculationExplanation:
        objectPage?.buyMethodsLoanCalculationExplanation
    },
    heavyEquipment: {
      descriptionWarning: objectPage?.heavyEquipmentDescriptionWarning,
      facilityExplanation: objectPage?.heavyEquipmentFacilityExplanation,
      salesTermsTitle: objectPage?.heavyEquipmentSalesTermsTitle,
      salesTerms: objectPage?.heavyEquipmentSalesTerms,
      vehicleFactsDisclaimer: objectPage?.heavyEquipmentVehicleFactsDisclaimer,
      servicesTitle: objectPage?.heavyEquipmentServicesTitle,
      services: objectPage?.heavyEquipmentServices
    },
    biddingGuide: {
      steps: objectPage?.guideSteps,
      buttons: {
        nextButton: objectPage?.nextButtonText,
        exitButton: objectPage?.exitButtonText,
        finalButton: objectPage?.finalButtonText
      },
      finalLink: objectPage?.finalLink
    },
    ecoFriendly: {
      title: objectPage?.ecoTitle,
      subtitle: objectPage?.ecoSubtitle,
      description: objectPage?.ecoDescription,
      bulletPoints: getBulletPoints(
        objectPage?.ecoBulletPoints as TextRecord[]
      ),
      imageDescription: objectPage?.ecoImageDescription,
      readMoreUrl: objectPage?.ecoReadMoreUrl,
      readMoreText: objectPage?.ecoReadMoreText
    },
    test: {
      overview: {
        title: objectPage?.inspectionOverview?.title,
        linkText: objectPage?.inspectionOverview?.link?.text,
        linkUrl: objectPage?.inspectionOverview?.link?.url
      },
      drivetrain: {
        title: objectPage?.drivetrain?.title,
        link: objectPage?.drivetrain?.link,
        conditions: objectPage?.drivetrain
          ?.conditions as ConditionInfoModelRecord[]
      },
      brakes: {
        title: objectPage?.brakes?.title,
        link: objectPage?.brakes?.link,
        conditions: objectPage?.brakes?.conditions as ConditionInfoModelRecord[]
      },
      technologyAndEquipment: {
        title: objectPage?.technologyAndEquipment?.title,
        link: objectPage?.technologyAndEquipment?.link,
        conditions: objectPage?.technologyAndEquipment
          ?.conditions as ConditionInfoModelRecord[]
      },
      interior: {
        title: objectPage?.interior?.title,
        link: objectPage?.interior?.link,
        conditions: objectPage?.interior
          ?.conditions as ConditionInfoModelRecord[]
      },
      exterior: {
        title: objectPage?.exterior?.title,
        link: objectPage?.exterior?.link,
        conditions: objectPage?.exterior
          ?.conditions as ConditionInfoModelRecord[]
      },
      tires: {
        title: objectPage?.tires?.title,
        link: objectPage?.tires?.link,
        conditions: objectPage?.tires?.conditions as ConditionInfoModelRecord[]
      }
    },
    kvdHelperUrl: objectPage?._editingUrl,
    objectCondition: objectPage?.objectCondition as ObjectConditionRecord[],
    deliveryCalculator: {
      title: objectPage?.deliveryCalculatorTitle,
      disclaimer: objectPage?.deliveryCalculatorDisclaimer
    }
  };
};

export const handleObjectServicesData = ({
  objectPage
}: Partial<ObjectServicesQuery>) => {
  return {
    servicesData: objectPage?.services,
    servicesTitle: objectPage?.servicesTitle,
    deliveryCalculator: {
      title: objectPage?.deliveryCalculatorTitle,
      descriptor: objectPage?.deliveryCalculatorDescriptor,
      disclaimer: objectPage?.deliveryCalculatorDisclaimer
    }
  };
};

export const handleFixedPriceReservationTipsData = ({
  fixedPriceTipsModel
}: Partial<FixedPriceReservationTipsQuery>) => {
  return {
    structuredText: fixedPriceTipsModel?.structuredText?.structuredText
  };
};
